import { AbstractControl } from '@angular/forms';

export function ValidateVersion(control: AbstractControl) {
  if (!(control.value as string).match(/\b\d+\.\d+\b/gi)) {
    return { validVersion: true };
  }
  return null;
}
